import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { api, formatApiErrorDetail } from "../lib/api";
import { AuthShell } from "./Login";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Set a new password" subtitle="Choose a new password for your founder account.">
      {!token ? (
        <p className="text-sm text-[#FCA5A5] font-mono-data">Missing or invalid reset link.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="font-mono-data text-xs uppercase tracking-wider text-ftext2">New password</Label>
            <Input data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="rounded-none bg-ink border-line2 focus-visible:ring-[#38BDF8]" />
          </div>
          {error && <p data-testid="reset-error" className="text-xs text-[#FCA5A5] font-mono-data">{error}</p>}
          <button data-testid="reset-submit-btn" type="submit" disabled={loading}
            className="w-full bg-sky hover:bg-skyH text-primary-foreground font-mono-data text-sm font-semibold uppercase tracking-wider px-4 py-3 transition-colors disabled:opacity-60">
            {loading ? "Updating…" : "Update password"}
          </button>
        </form>
      )}
      <Link to="/login" className="block mt-4 font-mono-data text-xs uppercase tracking-wider text-ftext3 hover:text-sky transition-colors">
        ← Back to sign in
      </Link>
    </AuthShell>
  );
}
